/**
 * Builds the request payload for video AI analysis.
 * Supports local File uploads (multipart) and library/CDN references (JSON).
 */

import {
  pickGeminiVideoUrl,
  GEMINI_HLS_ONLY_ERROR,
} from "./resolveVideoSource.js";

const isFileLike = (video) =>
  typeof File !== "undefined" &&
  (video instanceof File || video instanceof Blob);

export class VideoSourceError extends Error {
  constructor(message) {
    super(message);
    this.name = "VideoSourceError";
  }
}

export const buildVideoAnalyzePayload = (video) => {
  if (!video) return null;

  if (isFileLike(video)) {
    const formData = new FormData();
    formData.append("video", video, video.name || "upload.mp4");
    if (video.name) formData.append("filename", video.name);
    return { type: "multipart", body: formData };
  }

  const { url: video_url, source } = pickGeminiVideoUrl(video);

  if (!video_url) {
    throw new VideoSourceError(GEMINI_HLS_ONLY_ERROR);
  }

  return {
    type: "json",
    body: {
      video_id: video.id ?? null,
      video_url,
      video_source: source,
      filename: video.name || video.title || null,
      duration: video.duration ?? video.video_duration ?? video.length ?? null,
    },
  };
};

export default buildVideoAnalyzePayload;
